import { render, staticRenderFns } from "./MarketingRecommendExport.vue?vue&type=template&id=701216ac&scoped=true"
import script from "./MarketingRecommendExport.vue?vue&type=script&lang=js"
export * from "./MarketingRecommendExport.vue?vue&type=script&lang=js"
import style0 from "./MarketingRecommendExport.vue?vue&type=style&index=0&id=701216ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701216ac",
  null
  
)

export default component.exports